export default `
<g id="buttonhole">
  <path
    style="fill:none;stroke:var(--pattern-mark);stroke-width:var(--pattern-stroke);"
    d="M -1,-5 L 1,-5 L 1,5 L -1,5 z"
  />
</g>
<g id="buttonhole-start">
  <path
    style="fill:none;stroke:var(--pattern-mark);stroke-width:var(--pattern-stroke);"
    d="M -1,-10 L 1,-10 L 1,0 L -1,0 z"
  />
</g>
<g id="buttonhole-end">
  <path
    style="fill:none;stroke:var(--pattern-mark);stroke-width:var(--pattern-stroke);"
    d="M -1,0 L 1,0 L 1,10 L -1,10 z"
  />
</g>`

